<ng-container *transloco="let t">
  <app-nav-tabs [reduceHorizontalSpacing]=true>
    <app-nav-tab [title]="t('app.common.races')" [itemId]="1">
      <ng-template>
        <app-event-management-race-list [eventItem]="eventItem" [languages]="languages"
                                        [disableRegisterToRace]="disableRegisterToRace"
                                        (registerToRace)="registerToRace()"
                                        (generateRegistrationQRCode)="downloadRaceRegistrationQRCode()"
                                        (getFileFromServer)="downloadListOfRaces($event)"/>
      </ng-template>
    </app-nav-tab>
    <app-nav-tab [title]="t('organiser.event.management.participants')" [itemId]="2">
      <ng-template>
        <app-event-management-participants-list [languages]="languages" [filter]="filter" [searchForm]="searchForm"
                                                [event]="eventItem"
                                                [applicationFormSettingsList]="applicationFromSettingsList"
                                                [raceSettingsList]="settingsList"
                                                [disableRegisterToRace]="disableRegisterToRace"
                                                [raceAdditionalPricingItems]="raceAdditionalPricingItems"
                                                [raceCommercialItems]="raceCommercialItems"
                                                [competitors]="competitors"
                                                [countries]="countries"
                                                [genders]="genders"
                                                (refreshCounters)="onRefreshCounters()"
                                                (registerToRace)="registerToRace()"
                                                (printStartList)="downloadStartList()"
                                                (getFileFromServer)="downloadCompetitorsListForEvent($event.type, $event.filter)"/>
      </ng-template>
    </app-nav-tab>
    <app-nav-tab [title]="t('organiser.event.management.registrations')" [itemId]="3">
      <ng-template>
        <app-event-management-registrations-list [eventItem]="eventItem" [languages]="languages"
                                                 [raceRegistrations]="raceRegistrations"
                                                 [disableRegisterToRace]="disableRegisterToRace"
                                                 (registerToRace)="registerToRace()"
                                                 (getFileFromServer)="downloadListOfRaces($event)"/>

      </ng-template>
    </app-nav-tab>
    <app-nav-tab [title]="t('race.details.results')" [itemId]="4">
      <ng-template>
        <app-race-results-list-component [results]="results" [race]="eventItem!.racesList![0]" [eventItem]="eventItem"
                                         [genders]="genders" [showRaceNameInTable]="true"
                                         [languages]="languages" [categories]="categories"/>
      </ng-template>
    </app-nav-tab>
  </app-nav-tabs>
  <app-action-buttons-row [saveVisible]="false"/>
</ng-container>
